import config from 'config';

export const SUBMIT_BENTO_CART_ORDER_REQUEST =
  'SUBMIT_BENTO_CART_ORDER_REQUEST';
export const SUBMIT_BENTO_CART_ORDER_SUCCESS =
  'SUBMIT_BENTO_CART_ORDER_SUCCESS';
export const SUBMIT_BENTO_CART_ORDER_FAILURE =
  'SUBMIT_BENTO_CART_ORDER_FAILURE';

export const COMPLETE_BENTO_CART_ORDER_REQUEST =
  'COMPLETE_BENTO_CART_ORDER_REQUEST';
export const COMPLETE_BENTO_CART_ORDER_SUCCESS =
  'COMPLETE_BENTO_CART_ORDER_SUCCESS';
export const COMPLETE_BENTO_CART_ORDER_FAILURE =
  'COMPLETE_BENTO_CART_ORDER_FAILURE';

export const LOAD_BENTO_CART_REQUEST = 'LOAD_BENTO_CART_REQUEST';
export const LOAD_BENTO_CART_SUCCESS = 'LOAD_BENTO_CART_SUCCESS';
export const LOAD_BENTO_CART_FAILURE = 'LOAD_BENTO_CART_FAILURE';

export const ADD_GIFT_CERTIFICATE_REQUEST = 'ADD_GIFT_CERTIFICATE_REQUEST';
export const ADD_GIFT_CERTIFICATE_SUCCESS = 'ADD_GIFT_CERTIFICATE_SUCCESS';
export const ADD_GIFT_CERTIFICATE_FAILURE = 'ADD_GIFT_CERTIFICATE_FAILURE';

export const DELETE_GIFT_CERTIFICATE_REQUEST =
  'DELETE_GIFT_CERTIFICATE_REQUEST';
export const DELETE_GIFT_CERTIFICATE_SUCCESS =
  'DELETE_GIFT_CERTIFICATE_SUCCESS';
export const DELETE_GIFT_CERTIFICATE_FAILURE =
  'DELETE_GIFT_CERTIFICATE_FAILURE';

export const GET_GIFT_CERTIFICATE_REQUEST = 'GET_GIFT_CERTIFICATE_REQUEST';
export const GET_GIFT_CERTIFICATE_SUCCESS = 'GET_GIFT_CERTIFICATE_SUCCESS';
export const GET_GIFT_CERTIFICATE_FAILURE = 'GET_GIFT_CERTIFICATE_FAILURE';

export const BENTO_DELETE_BASKET_ITEMS_REQUEST =
  'BENTO_DELETE_BASKET_ITEMS_REQUEST';
export const BENTO_DELETE_BASKET_ITEMS_SUCCESS =
  'BENTO_DELETE_BASKET_ITEMS_SUCCESS';
export const BENTO_DELETE_BASKET_ITEMS_FAILURE =
  'BENTO_DELETE_BASKET_ITEMS_FAILURE';

export const UPDATE_BENTO_CART_WITH_ADDRESS_REQUEST =
  'UPDATE_BENTO_CART_WITH_ADDRESS_REQUEST';
export const UPDATE_BENTO_CART_WITH_ADDRESS_SUCCESS =
  'UPDATE_BENTO_CART_WITH_ADDRESS_SUCCESS';
export const UPDATE_BENTO_CART_WITH_ADDRESS_FAILURE =
  'UPDATE_BENTO_CART_WITH_ADDRESS_FAILURE';

export const UPDATE_BENTO_CART_WITH_PAYMENT_REQUEST =
  'UPDATE_BENTO_CART_WITH_PAYMENT_REQUEST';
export const UPDATE_BENTO_CART_WITH_PAYMENT_SUCCESS =
  'UPDATE_BENTO_CART_WITH_PAYMENT_SUCCESS';
export const UPDATE_BENTO_CART_WITH_PAYMENT_FAILURE =
  'UPDATE_CART_WITH_PAYMENT_FAILURE';

export const GIFT_CARD_BALANCE_REQUEST = 'GIFT_CARD_BALANCE_REQUEST';
export const GIFT_CARD_BALANCE_SUCCESS = 'GIFT_CARD_BALANCE_SUCCESS';
export const GIFT_CARD_BALANCE_FAILURE = 'GIFT_CARD_BALANCE_FAILURE';

const xApiKey = config.get('public.bentoApi.bentoCart.key');

function getCustomHeaders() {
  const headers = {};

  headers['x-api-key'] = xApiKey;

  return headers;
}

export function getSubmitCartOrderEndpoint(paymentProvider, paymentType) {
  const isAdyen = paymentProvider === 'adyen' && paymentType === 'creditcard';

  return isAdyen ? 'cart/purchase' : 'cart/order/submit';
}

export function loadCart(options = {}) {
  return async (dispatch, getState, context) => {
    if (options.ifNotFetched) {
      const { checkout } = getState();
      if (checkout.fetchedDate) {
        return;
      }
    }
    let request = context.inflightCartRequest;
    const timestamp = Date.now();
    if (!context.inflightCartRequest) {
      request = dispatch({
        bentoApi: {
          endpoint: `cart?noCache=true&timestamp=${timestamp}`,
          method: 'GET',
          headers: getCustomHeaders(),
          actions: [
            LOAD_BENTO_CART_REQUEST,
            LOAD_BENTO_CART_SUCCESS,
            LOAD_BENTO_CART_FAILURE,
          ],
        },
      });
      context.inflightCartRequest = request;

      context.inflightCartRequest = null;
    }
    return request;
  };
}

/**
export interface IAddGiftCard {
  amount: number;
  comment?: string;
  giftCertificateTypeId: number;
  productId: number;
  recipientAddress1?: string;
  recipientAddress2?: string;
  recipientCity?: string;
  recipientCountryCode?: string;
  recipientEmail: string;
  recipientFirstname?: string;
  recipientLastname?: string;
  recipientState?: string;
  recipientZip?: string;
}
*/
export function addGiftCertificate(giftCertifcatePayload) {
  return (dispatch, getState, context) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/giftcards`,
        method: 'POST',
        headers: getCustomHeaders(),
        actions: [
          ADD_GIFT_CERTIFICATE_REQUEST,
          ADD_GIFT_CERTIFICATE_SUCCESS,
          ADD_GIFT_CERTIFICATE_FAILURE,
        ],
        body: JSON.stringify(giftCertifcatePayload),
      },
    });
  };
}

export function getGiftCertificate(cartLineId) {
  return (dispatch, getState, context) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/giftcards/${cartLineId}`,
        method: 'GET',
        headers: getCustomHeaders(),
        actions: [
          GET_GIFT_CERTIFICATE_REQUEST,
          GET_GIFT_CERTIFICATE_SUCCESS,
          GET_GIFT_CERTIFICATE_FAILURE,
        ],
      },
    });
  };
}

export function deleteGiftCertificate(cartLineId) {
  return (dispatch, getState, context) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/giftcards/${cartLineId}`,
        method: 'DELETE',
        headers: getCustomHeaders(),
        actions: [
          DELETE_GIFT_CERTIFICATE_REQUEST,
          DELETE_GIFT_CERTIFICATE_SUCCESS,
          DELETE_GIFT_CERTIFICATE_FAILURE,
        ],
      },
    });
  };
}

export function deleteBasketItem(itemId) {
  return async (dispatch, getState) => {
    const request = {
      bentoApi: {
        endpoint: `cart/items/${itemId}`,
        method: 'DELETE',
        headers: getCustomHeaders(),
        actions: [
          BENTO_DELETE_BASKET_ITEMS_REQUEST,
          (payload, extraMeta) => {
            return {
              type: BENTO_DELETE_BASKET_ITEMS_SUCCESS,
              meta: {
                ...extraMeta,
              },
              payload,
            };
          },
          BENTO_DELETE_BASKET_ITEMS_FAILURE,
        ],
      },
    };

    const result = await dispatch(request);

    return result;
  };
}

export function submitCartOrder(params = {}) {
  return async (dispatch, getState) => {
    const state = getState();
    const { storeGroup } = state;
    const endpoint = getSubmitCartOrderEndpoint(
      storeGroup.paymentOptions.paymentProvider,
      params.paymentType
    );

    const requestJSON = JSON.stringify(params);

    const request = {
      bentoApi: {
        endpoint: endpoint,
        method: 'POST',
        headers: getCustomHeaders(),
        body: requestJSON,
        retry: { retries: 0 },
        actions: [
          SUBMIT_BENTO_CART_ORDER_REQUEST,
          SUBMIT_BENTO_CART_ORDER_SUCCESS,
          SUBMIT_BENTO_CART_ORDER_FAILURE,
        ],
      },
    };

    const result = await dispatch(request);

    if (
      result.payload &&
      result.payload.statusCode !== 202 &&
      !result.payload.adyenResponseType
    ) {
      // dispatch({
      //   ...result,
      //   type: COMPLETE_CART_ORDER_SUCCESS,
      // });
    }
    return result;
  };
}

export function completeCartOrder(params = {}, onAuthorizationStep = () => {}) {
  return async (dispatch, getState) => {
    const { isAdyen } = params;

    const buildRequest = requestParams => {
      return {
        bentoApi: {
          endpoint: isAdyen ? 'cart/purchase/complete' : 'cart/order/complete',
          method: 'POST',
          headers: getCustomHeaders(),
          body: JSON.stringify(requestParams),
          retry: { retries: 0 },
          actions: [
            COMPLETE_BENTO_CART_ORDER_REQUEST,
            COMPLETE_BENTO_CART_ORDER_SUCCESS,
            COMPLETE_BENTO_CART_ORDER_FAILURE,
          ],
        },
      };
    };
    let result = await dispatch(buildRequest(params));

    // 3DS2 will sometimes require us to authenticate the user,
    // which we do here (and then resubmit with new authentication):
    if (
      result.payload.adyenResponseType === 'threeDS2Challenge' ||
      result.payload.adyenResponseType === 'redirect'
    ) {
      const newParams = await onAuthorizationStep(result.payload);
      result = await dispatch(buildRequest(newParams));
    }

    if (isAdyen) {
      // call GTM for vip conversion for adyen checkout
      dispatch({
        ...result,
        type: COMPLETE_BENTO_CART_ORDER_SUCCESS,
      });
    }
  };
}

export function updateCartWithAddress(addressId, addressType = 'shipping') {
  return (dispatch, getState, context) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/addresses`,
        method: 'POST',
        headers: getCustomHeaders(getState()),
        actions: [
          UPDATE_BENTO_CART_WITH_ADDRESS_REQUEST,
          UPDATE_BENTO_CART_WITH_ADDRESS_SUCCESS,
          UPDATE_BENTO_CART_WITH_ADDRESS_FAILURE,
        ],
        body: JSON.stringify({
          addressId: addressId,
          addressType,
        }),
      },
    });
  };
}

export function updateCartWithPayment(paymentMethod) {
  return async (dispatch, getState, context) => {
    return dispatch({
      bentoApi: {
        endpoint: `cart/payment`,
        method: 'POST',
        headers: getCustomHeaders(),
        actions: [
          UPDATE_BENTO_CART_WITH_PAYMENT_REQUEST,
          UPDATE_BENTO_CART_WITH_PAYMENT_SUCCESS,
          UPDATE_BENTO_CART_WITH_PAYMENT_FAILURE,
        ],
        body: JSON.stringify(paymentMethod),
      },
    });
  };
}

export function initCheckout() {
  return async (dispatch, getState) => {
    await dispatch(loadCart());
  };
}

export function getGiftCardBalance(giftCardNumber) {
  return async (dispatch, getState) => {
    return dispatch({
      bentoApi: {
        endpoint: `promos/${giftCardNumber}/balance`,
        method: 'GET',
        actions: [
          GIFT_CARD_BALANCE_REQUEST,
          GIFT_CARD_BALANCE_SUCCESS,
          GIFT_CARD_BALANCE_FAILURE,
        ],
      },
    });
  };
}
